"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const GroupPane_1 = require("../../../elements/GroupPane");
const Label_1 = __importDefault(require("../../../elements/Label"));
const FormikCheckBox_1 = __importDefault(require("../../../elements/formik/FormikCheckBox"));
const FormikInput_1 = __importDefault(require("../../../elements/formik/FormikInput"));
const FormikSelect_1 = __importDefault(require("../../../elements/formik/FormikSelect"));
const SHAPE_RENDERING = [
    {
        label: 'Auto',
        value: 'auto',
    },
    {
        label: 'Optimize speed',
        value: 'optimizeSpeed',
    },
    {
        label: 'Crisp edges',
        value: 'crispEdges',
    },
    {
        label: 'Geometric precision',
        value: 'geometricPrecision',
    },
];
const LOGS_LEVELS = [
    'fatal',
    'error',
    'warn',
    'info',
    'debug',
    'trace',
    'silent',
].map((level) => ({
    label: level.replace(/^\w/, (c) => c.toUpperCase()),
    value: level,
}));
function GeneralTabContent() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Spectra", children: (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Opacity of dimmed spectra [ 0 - 1 ]", children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "general.dimmedSpectraOpacity", checkValue: (value) => Number(value) >= 0 && Number(value) <= 1, type: "number", step: 0.1, min: 0, max: 1 }) }) }), (0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Experimental features", children: (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Enable experimental features", htmlFor: "display.general.experimentalFeatures.display", children: (0, jsx_runtime_1.jsx)(FormikCheckBox_1.default, { name: "display.general.experimentalFeatures.display" }) }) }), (0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Rendering", children: (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Spectra rendering ", children: (0, jsx_runtime_1.jsx)(FormikSelect_1.default, { items: SHAPE_RENDERING, name: "general.spectraRendering", style: { width: '150px' } }) }) }), (0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Logging settings", children: (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Level ", children: (0, jsx_runtime_1.jsx)(FormikSelect_1.default, { items: LOGS_LEVELS, name: "general.loggingLevel", style: { width: '100px' } }) }) })] }));
}
exports.default = GeneralTabContent;
